query BrandsForBrandsConsole {
    brands {
        id

        name

        legacyAlias
        legacyID
    }
}
